import { render, staticRenderFns } from "./LoadingIndicator.vue?vue&type=template&id=87b20fa8&scoped=true&"
import script from "./LoadingIndicator.vue?vue&type=script&lang=js&"
export * from "./LoadingIndicator.vue?vue&type=script&lang=js&"
import style0 from "./LoadingIndicator.vue?vue&type=style&index=0&id=87b20fa8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b20fa8",
  null
  
)

export default component.exports